export interface MockDateOffset
{
    week?: number;
    weeks?: number;
    day?: number;
    days?: number;
    hour?: number;
    hours?: number;
    minute?: number;
    minutes?: number;
}

export interface MockDateTime
{
    hour?: number;
    minute?: number;
}

/**
 * Data ISO relativa a "agora" para os dados de demonstração do mock-api,
 * sem depender de uma biblioteca de datas no bundle inicial.
 */
export function mockDate(minus: MockDateOffset = {}, set: MockDateTime = {}): string
{
    const date = new Date();
    const weeks = (minus.week ?? 0) + (minus.weeks ?? 0);
    const days = (minus.day ?? 0) + (minus.days ?? 0);
    const hours = (minus.hour ?? 0) + (minus.hours ?? 0);
    const minutes = (minus.minute ?? 0) + (minus.minutes ?? 0);
    date.setDate(date.getDate() - weeks * 7 - days);
    date.setHours(date.getHours() - hours, date.getMinutes() - minutes);
    if (set.hour !== undefined || set.minute !== undefined)
    {
        date.setHours(set.hour ?? date.getHours(), set.minute ?? date.getMinutes(), 0, 0);
    }
    return date.toISOString();
}
